import { mfaStateRequest } from '@/api/requests/mfa-state-request';
import { MFA_STATE } from '@/api/endpoints/passport';

export const getMfaState = async (deviceId: string) => {
  const {
    data: { sticker },
    error: MfaStateError,
    errorText: MfaStateErrorText,
  } = await mfaStateRequest({
    endpoint: MFA_STATE,
    deviceId,
    middlewaresAreDisabled: true,
  });

  if (MfaStateError) {
    throw new Error(`Error to get state ${MfaStateErrorText}`);
  }

  return sticker;
};
